var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen overflow-hidden"},[_c('div',{staticClass:"w-full h-full relative"},[_c('div',{staticClass:"w-full h-full overflow-auto",class:[_vm.extraClass]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }